export default {
  dbi_download_page_title: '下载',
  dbi_download_page_hour: '小时',
  dbi_download_page_hours: '小时',
  dbi_download_page_minute: '分钟',
  dbi_download_page_minutes: '分钟',
  dbi_download_page_second: '秒',
  dbi_download_page_seconds: '秒',
  dbi_download_page_short_waitting_tips: '您的下载已经开始，请稍候。',
  dbi_download_page_long_waitting_tips: '您所选文件的预计下载时间为{time}。',
  dbi_download_page_failly_tips: '下载失败，请返回下载页面重试。',
  dbi_download_page_no_close_tips: '下载过程中请不要关闭标签页。',
  dbi_download_page_maximum_number_of_rows_tips: '• 当前最大行数为 100,000，剩余数据将不会下载到 excel 中。',
  dbi_download_modal_chart: '图表',
  dbi_download_modal_linechart_type: '折线图',
  dbi_download_modal_shadowchart_type: '阴影图',
  dbi_download_modal_chart_size: '尺寸',
  dbi_download_modal_chart_title: '标题',
  dbi_download_modal_chart_title_tips: '包含图表标题（数据源图标）和排名',
  dbi_download_modal_chart_peak: ' 峰值和日期',
  dbi_download_modal_chart_total: '总值和时间段',
  dbi_download_modal_chart_peak_subtitle: '最大峰值',
  dbi_download_modal_chart_total_subtitle: '总值',
  dbi_download_modal_chart_preview: '预览',
  dbi_download_modal_chart_preview_tips: '包含起始日期、结束日期、峰值日期和相关数据',
  dbi_download_modal_chart_dark: '应用于深色背景',
  dbi_download_modal_setting_title: '图表下载设置',
  dbi_download_modal_download_the_charts: '下载图表',
  dbi_download_modal_download_the_metrics_data: '下载数据',
  dbi_download_modal_loading_failed: '加载失败，请',
  dbi_download_modal_loading_failed_try_again: '重试',
  dbi_download_chart_modal_no_data: '暂无数据',
  dbi_download_common_error_tips: '下载失败，请重试',
};
